import { createFileRoute } from '@tanstack/react-router';

import { NIS2PolicyGovernancePage } from '@/features/nis2/components/NIS2PolicyGovernancePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/policy-governance')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2PolicyGovernance'),
  }),
  component: NIS2PolicyGovernancePage,
});
